import {SpinnerLogoDefaultBox} from './spinner-logo.default.box';
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {SpinnerLogoCasino777Box} from "./spinner-logo.casino777.box";
import {SpinnerLogoCIPBox} from "./spinner-logo.cip.box";
import {SpinnerLogoWSOPBox} from "./spinner-logo.wsop.box";
import {SpinnerLogoCISBox} from "./spinner-logo.cis.box";

//TODO: change accordingly when we have the spritesheet with 888sport spinner logo
export const SpinnerLogoBox = styledByTheme(SpinnerLogoDefaultBox)
                             .forCasino777(SpinnerLogoCasino777Box)
                             .forCip(SpinnerLogoCIPBox)
                             .forWsopCip(SpinnerLogoWSOPBox)
                             .forWsop(SpinnerLogoWSOPBox)
                             .forCis(SpinnerLogoCISBox)
                             .apply();